import { Swiper, SwiperSlide } from "swiper/react";
import "./swiperproduct.scss";
import { HTMLAttributes } from "react";
import { Link } from "react-router";
import CardPodcast from "../../Cards/CardPodcast/CardPodcast";
import {
  ICardResponse,
  ILinkModel,
  IMiniListResponseModel,
} from "../../../core/models";
import CardNews from "../../Cards/CardNews/CardNews";
import CardMultimedya from "../../Cards/CardMultimedya/CardMultimedya";
import CardDocument from "../../Cards/CardDocument/CardDocument";
import CardDocumentList from "../../Cards/CardDocumentList/CardDocumentList";

export interface ISwiperProductProps extends HTMLAttributes<HTMLDivElement> {
  props?: IMiniListResponseModel;
}

const SwiperProduct = ({ props }: ISwiperProductProps) => {
  return (
    <section
      className={
        "swiper-product " +
        (props?.mini_list?.cards?.length &&
        props?.mini_list?.cards?.at(0)?.type === "Dökümanlar"
          ? "document"
          : "")
      }
    >
      <div className="swiper-product__head">
        <h2>{props?.mini_list?.title}</h2>
        <div className="swiper-product__action">
          {props?.mini_list?.button_items?.map((action: ILinkModel) => {
            return (
              <Link
                to={{
                  pathname: action.url ?? "",
                }}
                target={action.target ?? "_self"}
              >
                {action.title}
              </Link>
            );
          })}
        </div>
      </div>
      <div className="swiper-product__cards">
        {props?.mini_list?.cards?.length &&
        props.mini_list.cards.at(0)?.type === "Dökümanlar" ? (
          <ul className="section-document__cards">
            {props?.mini_list?.cards?.map(
              (card: ICardResponse, index: number) => {
                return (
                  <li key={index}>
                    <CardDocumentList props={card} />
                  </li>
                );
              }
            )}
          </ul>
        ) : (
          <Swiper
            spaceBetween={8}
            slidesPerView={2}
            speed={800}
            style={{ overflow: "visible" }}
          >
            {props?.mini_list?.cards?.map(
              (card: ICardResponse, index: number) => {
                return (
                  <SwiperSlide key={index}>
                    {
                      {
                        Dökümanlar: <CardDocument props={card} />,
                        Podcast: <CardPodcast props={card} />,
                        Haberler: <CardNews props={card} />,
                        Multimedya: <CardMultimedya props={card} />,
                      }[card.type]
                    }
                  </SwiperSlide>
                );
              }
            )}
          </Swiper>
        )}
      </div>
    </section>
  );
};

export default SwiperProduct;
